import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { X, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EditorPasswordModal = ({ headers, onClose, forced = false }) => {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  useEffect(() => {
    const onKey = (e) => !forced && e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, forced]);
  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.next.length < 6) return setError('A nova senha deve ter pelo menos 6 caracteres');
    if (form.next !== form.confirm) return setError('As senhas não coincidem');
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: form.current, new_password: form.next }, { headers });
      alert('Senha alterada com sucesso!');
      onClose();
    } catch (err) {
      setError(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Erro ao alterar senha');
    } finally {
      setSaving(false);
    }
  };
  return (
    <div onClick={forced ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="editor-password-modal" style={{ background: 'white', borderRadius: 14, padding: '1.5rem', width: '100%', maxWidth: 400 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
          <h3 style={{ fontWeight: 700, color: '#2D3748' }}>{forced ? 'Defina sua nova senha' : 'Alterar minha senha'}</h3>
          {!forced && <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X className="w-5 h-5" /></button>}
        </div>
        {forced && <p data-testid="forced-password-note" style={{ fontSize: '0.85rem', color: '#4A5568', marginBottom: '0.75rem' }}>No primeiro acesso, troque a senha provisória por uma senha pessoal. Use a senha provisória como "Senha atual".</p>}
        {error && <p data-testid="editor-password-error" style={{ color: '#c53030', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{error}</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <div><Label>Senha atual</Label><Input type="password" value={form.current} onChange={set('current')} required data-testid="editor-current-password" /></div>
          <div><Label>Nova senha</Label><Input type="password" value={form.next} onChange={set('next')} required data-testid="editor-new-password" /></div>
          <div><Label>Confirmar nova senha</Label><Input type="password" value={form.confirm} onChange={set('confirm')} required data-testid="editor-confirm-password" /></div>
        </div>
        <Button type="submit" disabled={saving} style={{ width: '100%', marginTop: '1.25rem', background: '#68AAB0' }} data-testid="editor-password-submit">
          {saving && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Salvar nova senha
        </Button>
      </form>
    </div>
  );
};
